import { toast } from 'react-toastify';
import { fetchOnboardingMe, sendUserOTP, login, signup, verifyOTP } from '../services/auth';
import { useNavigate } from 'react-router-dom';
import { encodeEmailToToken } from '../utils/controller';
import { setAuthTokenToLocalStorage } from '../utils';
import { useDispatch } from 'react-redux';
import { setAuthToken, setIsOnboardingCompleted } from '../store/action/userInfo';

const useAuth = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const userSignup = async (params) => {
		try {
			const data = await signup(params);
			if (!data.success) {
				toast.error(data.message || 'Something went wrong!');
				return data;
			} else {
				if (data.token) {
					setAuthTokenToLocalStorage(data.token);
					dispatch(setAuthToken({ authToken: data.token }));
				}
				return data;
			}
		} catch (error) {
			toast.error('Something went wrong! while signing up.');
		}
	};

	const userOTPVerification = async (params) => {
		try {
			const data = await verifyOTP(params);
			if (!data.success) {
				toast.error(data.message || 'Something went wrong! while verifying the OTP.');
				return;
			}
			if (data.token) {
				setAuthTokenToLocalStorage(data.token);
				dispatch(setAuthToken({ authToken: data.token }));
			}
			toast.success('OTP verified successfully');
			return data;
		} catch (error) {
			toast.error('Something went wrong! while verifying the OTP.');
			throw error;
		}
	};

	const userLogin = async (params) => {
		try {
			const { email, password, subdomain } = params;
			const data = await login({ email, password, subdomain });
			if (!data.success) {
				toast.error(data?.message || 'Something went wrong!');
				return data;
			} else {
				// TODO store the auth token and onboarding status with userinfo
				setAuthTokenToLocalStorage(data.token);
				dispatch(setAuthToken({ authToken: data.token }));
				window.dispatchEvent(new Event('auth-change'));
				return data;
			}
		} catch (error) {
			toast.error('Something went wrong! while login.');
			throw error;
		}
	};

	const userOnboardingMe = async (params) => {
		try {
			const data = await fetchOnboardingMe();
			if (!data.success) {
				toast.error('Something went wrong! while fetching the onboarding status.');
				return;
			}

			const onboarding = data.data;
			const status = onboarding.onboarding_status;

			switch (status) {
				case 'FORGOT_PASSWORD':
					navigate('/createNewPassword');
					break;
				case 'REGISTERED':
				case 'OTP_PENDING': {
					if (!params?.email) {
						toast.error('Email is missing. Please login again.');
						return;
					}

					const data = await sendUserOTP(params.email);

					if (!data.success) {
						toast.error(data.message || 'Failed to send OTP');
						return;
					}

					toast.success('Please verify the email.');
					const token = encodeEmailToToken(params.email);
					navigate(`/otpVerify/?token=${token}&page_login=true`);
					break;
				}
				case 'VERIFIED':
				case 'ORG_DRAFT':
					navigate('/organizationDetail');
					break;

				case 'COMPLETED': {
					const sub_domain = onboarding.sub_domain;
					dispatch(setIsOnboardingCompleted({ isOnboardingCompleted: true }));
					localStorage.setItem('suburl', sub_domain);
					if (params.redirectParam) {
						navigate(`/user/${sub_domain}/${params.redirectParam}`);
					} else {
						navigate(`/user/${sub_domain}/home`);
					}
					break;
				}

				default:
					navigate('/');
			}
		} catch (error) {}
	};

	return { userOnboardingMe, userLogin, userSignup, userOTPVerification };
};

export default useAuth;
